import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import PendingReviewCard from '../PendingReview/PendingReviewCard';
import PendingReviewList from '../PendingReview/PendingReviewList';
import PendingReviewEmptyState from '../PendingReview/PendingReviewEmptyState';
import { PENDING_REVIEW_VIEW } from '../../constants';
import { mapPendingReviewItem } from '../PendingReview/utils';
import {
  LISTING_EDITION_REVIEW,
  PARAMS_QUERY_KEYS,
} from '@/components/Developments/constants';
import Trans from '@/components/shared/Trans';
import translations from '../../Dashboard.trans.json';
import { getDevelopmentsPendingReview } from '@/store/slices/components/dashboard/service';
import useFetchDashboard from '../../customHooks/useFetchDashboard';
import { useTrackPendingTab } from '../../customHooks/useTrackDashboard';
import DevelopmentIcon from '@/public/images/dashboard/development.svg';

function DevelopmentsPendingReview() {
  const dispatch = useDispatch();
  const track = useTrackPendingTab();
  const [viewMode, setViewMode] = useState(PENDING_REVIEW_VIEW.NEW);
  const pendingReview = useSelector(
    (state) => state.DashboardSlice.developmentsPendingReview
  );
  const { loading, hasFetched } = pendingReview;
  const { count, empty, items } = pendingReview[viewMode] ?? {};
  const { data: userData } = useSelector((state) => state.UserSlice);
  const { ref, isStale, useFetchOnViewport } = useFetchDashboard();
  const mappedItems = (items ?? []).map(mapPendingReviewItem);

  useFetchOnViewport(
    (query) => {
      dispatch(getDevelopmentsPendingReview({ query }));
    },
    [],
    { hasFetched }
  );

  const handleItemClick = (item) => {
    if (!item?.id) return;

    // New listings have no change request to review yet: they go to the
    // development's page in tokkobroker.
    if (viewMode === PENDING_REVIEW_VIEW.NEW) {
      const tokkoBrokerHost = localStorage.getItem('tokkoBrokerHost');
      window.open(
        `${tokkoBrokerHost}/development/${item.id}`,
        '_blank',
        'noopener,noreferrer'
      );
      return;
    }

    window.open(
      `/change-requests?development=${item.id}`,
      '_blank',
      'noopener,noreferrer'
    );
  };

  const handleViewModeChange = (nextViewMode) => {
    setViewMode(nextViewMode);
  };

  const statusParam =
    viewMode === PENDING_REVIEW_VIEW.MODIFIED
      ? PARAMS_QUERY_KEYS.COMMERCIALIZATION
      : PARAMS_QUERY_KEYS.DATA_LOADING;
  const showAllUrl = `/developments?review=${LISTING_EDITION_REVIEW.PENDING}&${statusParam}=true`;

  return (
    <PendingReviewCard
      cardRef={ref}
      loading={loading || isStale}
      empty={empty}
      title={Trans(translations, 'DevelopmentsPendingReview')}
      count={count}
      viewMode={viewMode}
      onViewModeChange={handleViewModeChange}
      redirectUrl={showAllUrl}
      trackCallback={(element) => track.developmentsPendingReview(element)}
      locale={userData?.user_language}
      emptyState={
        <PendingReviewEmptyState
          icon={DevelopmentIcon}
          titleKey="NoDevelopmentsPendingReview"
          descriptionKey="DevelopmentsPendingReviewEmptyDescription"
        />
      }
    >
      <PendingReviewList
        items={mappedItems}
        viewMode={viewMode}
        entityType="development"
        onItemClick={handleItemClick}
        trackCallback={(element) => track.developmentsPendingReview(element)}
      />
    </PendingReviewCard>
  );
}

export default DevelopmentsPendingReview;
